import { useEffect, useRef } from 'react';

export default function useClickOutside(callback: (event?: any) => void) {
    const ref = useRef(null);

    useEffect(() => {
        const handleClick = (event: any) => {
            if (ref.current && !(ref.current as any).contains(event.target)) {
                callback(event);
            }
        };

        document.addEventListener('click', handleClick, true);

        return () => {
            document.removeEventListener('click', handleClick, true);
        };
    }, [ref]);

    return ref;
}
